import { createSlice } from '@reduxjs/toolkit';

import {
	handleAsyncThunkActionState,
	initialAsyncState,
	isAsyncThunkActionWithPrefix
} from '../utils';
import { fetchPublicTransaction } from './thunks';

const initialState = {
	renderKey: 0,
	filePath: null,
	metadata: null,
	status: null,
	fetchPublicTransaction: initialAsyncState,
	initialized: false,
	pageNumber: 1,
	pagesCount: 0,
	viewPagesCount: 0,
	pageOrder: [],
	scale: 1,
	presetValue: null
};

const shareSlice = createSlice(
	{
		name: 'share',
		initialState,
		reducers: {
			init(state, action) {
				const { pagesCount, viewPagesCount, pageOrder } = action.payload;

				state.initialized = true;
				state.pagesCount = pagesCount;
				state.viewPagesCount = viewPagesCount;
				state.pageOrder = pageOrder;
			},
			clear(state) {
				return {
					...initialState,
					signatureFontsLoaded: state.signatureFontsLoaded
				};
			},
			setPageNumber(state, action) {
				state.pageNumber = action.payload;
			},
			setScale(state, action) {
				const { scale, presetValue } = action.payload;
				state.scale = scale;
				state.presetValue = presetValue;
			}
		},
		extraReducers(builder) {
			builder.addCase(fetchPublicTransaction.fulfilled, (state, action) => {
				state.filePath = action.payload.filePath;
				state.metadata = action.payload.metadata;
				state.status = action.payload.status;
			});

			builder.addMatcher(
				isAsyncThunkActionWithPrefix('share'),
				handleAsyncThunkActionState()
			);
		}
	},
	initialState
);

export const { init, clear, setPageNumber, setScale } = shareSlice.actions;

export default shareSlice.reducer;
